// extracted by mini-css-extract-plugin
module.exports = {"title":"MobilePurpleBanner_title__d_SXJ","cardBtn":"MobilePurpleBanner_cardBtn__BbP70","card":"MobilePurpleBanner_card__3y4Py"};